import { generateSetChild } from '@/helpers/VuexHelpers'
import { service } from '@/service'
import CheckoutTimeUtil from '@/helpers/CheckoutTimeUtil'
import { dayjs, dayjsLocal, isSameDay, timeZone } from "@/helpers/dayjs"
import { config } from '@/config'

//helper instance
let timeUtil = new CheckoutTimeUtil()

export default {
	namespaced: true,
	state: {
		queryLocations: [],
		deliveryMethod: "", // takeaway, delivery
		locations: [],
		//location: null,
		orderDate: null,
		orderTime: null,
		deliveryTime: null, // timespan in minutes to deliver
		orderNow: false,
		orderZip: null,
		orderNowAvailable: false,
		loading: true,
	},
	actions: {
		async query({state, commit}, {zip, deliveryMethod}) {
			try {
				let result = await service.locationQuery({zip, brand: config.BRAND, deliveryMethod})
				commit('setQueryLocations', {item: result.zipLocations})
				return {
					list: result.zipLocations,
					zip: result.zip
				}
			} catch(err) {
				//fix an 404
				if (err.response.data && err.response.data.code == 404) {
					commit('setQueryLocations', {item: []})
					return {
						zip,
						list: []
					}
				}
				// console.error(err)
				throw err
			}

		},
		async getLocations({state, commit}) {
			commit('setLoading', { item: true });
			let result
			try {
				// TODO: this depends on the implementation if we have to reduce the resuld
				result = await service.locations({ brand: config.BRAND, deliveryMethod: ""})

				// TODO: prepare this object for fast query

				commit('setLocations', { item: result })
			} catch(err) {
				result = null
			}
			commit('setLoading', { item: false });
			return result
		},
		setLocation({ state, commit, getters }, { location, deliveryMethod, deliverTime = null, zip = null, canOrderNow = null, deliveryTime = config.DELIVERY_TIME }) {
			commit('setDeliveryMethod', { item: deliveryMethod })
			commit('setLocation', { item: location })
			if (zip) {
				commit('setOrderZip', { item: zip })
			}
			if (deliveryTime) {
				commit('setDeliveryTime', { item: deliveryTime })
			}
			if (canOrderNow == null) {
				if (deliveryMethod == 'delivery') {
					if (zip != null) {
						canOrderNow = !!zip.orderNowAvailable
					}
				}

				if (deliveryMethod == 'takeaway') {
					canOrderNow = !!location.location.takeaway.orderNowAvailable
				}
			}

			commit('setOrderNowAvailable', { item: canOrderNow })
			commit('setOrderNow', { item: false })

			timeUtil.clearCache()

			let orderDate = getters.locationOrderMinDate.format('L')
			if (deliverTime) {
				orderDate = deliverTime.format('L')
			}
			commit('setOrderDate', { item: orderDate })

			let orderTime = getters.locationOrderTimes[0]?.value || getters.locationOrderTimes[0]
			const openingTimes = getters.locationOpeningTimes
			if (deliverTime && timeUtil.isOpenAt(deliverTime, openingTimes)) {
				orderTime = deliverTime.format('LT')
			}
			commit('setOrderTime', { item: orderTime })
		},
		clearLocation({ state, commit}) {
			if (state.location) {
				commit('setDeliveryMethod', { item: null })
				commit('setLocation', { item: null })
				commit('setOrderTime', { item: null })
				commit('setOrderDate', { item: null })
				commit('setOrderNow', { item: false })
				commit('setOrderZip', { item: null })
				commit('setOrderNowAvailable', { item: false })
				commit('setDeliveryTime', { item: null })
			}
		},
		setOrderDate({ state, commit }, { date, dateStr }) {
			commit('setOrderDate', { item: date || dateStr })
		},
		setOrderTime({ state, commit }, { timeStr }) {
			commit('setOrderTime', { item: timeStr })
		},
		setOrderNow({ state, commit }, { value }) {
			commit('setOrderNow', { item: value });
		},
	},
	getters: {
		queryLocations(state) {
			return state.queryLocations
		},
		locations(state) {
			return state.locations
		},
		location(state) {
			return state.location
		},
		locationOrderZip(state) {
			return state.orderZip
		},
		locationOpeningTimes(state, getters, rootState) {
			if (!state.location) {
				return []
			}
			const shipmentId = state.deliveryMethod
			const times = state.location.location[shipmentId]?.openingHours || []
			return timeUtil.filterOpeningTimes(times, state.orderZip?.zip || 0);
		},
		locationOrderNow(state) {
			return state.orderNow;
		},
		locationOrderNowAvailable(state, getters) {
			const disabledDates = getters.locationOrderDisabledDates;
			const timeNow = getters.locationTimeNow;
			const availableToday = !disabledDates.find(d => isSameDay(d, timeNow));

			return state.orderNowAvailable && availableToday;
		},
		locationOrderMinDate(state, getters) {
			// HACK: this is not the real min date, because the current day can be closed, but it needs it currently to display
			return getters.locationTimeNow
			// const openingTimes = getters.locationOpeningTimes
			// return timeUtil.getMinDate(openingTimes)
		},
		locationOrderMaxDate(state, getters) {
			const openingTimes = getters.locationOpeningTimes
			return timeUtil.getMaxDate(openingTimes)
		},
		locationTimeNow() {
			return dayjs(config.LOCAL_TIME).tz(timeZone)
		},
		locationOrderDate(state) {
			return state.orderDate
		},
		locationOrderTime(state) {
			return state.orderTime
		},
		locationOrderDateTime(state) {
			if (state.orderDate) {
				let datetime = dayjsLocal(state.orderDate+" 12:00")
				if (state.orderTime) {
					let spl = state.orderTime.split(":")
					datetime = datetime.hour(spl[0]).minute(spl[1]).second(0)
				}
				return datetime
			}
			return null
		},

		locationOrderDisabledDates(state, getters, rootState) {
			const openingTimes = getters.locationOpeningTimes
			const minDate = getters.locationOrderMinDate
			return timeUtil.getDisabledDates(openingTimes, minDate)
		},

		locationOrderTimes(state, getters, rootState, rootGetters) {
			//TODO: check orderDate
			if (state.orderDate) {
				const openingTimes = getters.locationOpeningTimes
				return timeUtil.getOrderTimes(
					openingTimes,
					getters.locationOrderDateTime,
					getters.locationTimeNow.add(state.deliveryTime || config.DELIVERY_TIME, 'minute'), // TODO: we do not know what the current delivery time is, but it could be provided with the locations zip
					state.deliveryMethod == 'delivery' ? config.DELIVERY_TIMESLOT : config.TAKEAWAY_TIMESLOT,
					config.FEATURE_TIMESLOTS
				)
			}
			return []
		},
		locationOrderTimeslot(state, getters) {
			return config.FEATURE_TIMESLOTS && state.orderTime
				? getters.locationOrderTimes.find(time => time.value == state.orderTime)?.label || null
				: null;
		},
		locationYieldingMessages(state) {
			return state.location.location && state.location.location.yieldingMessages
				? state.location.location.yieldingMessages.map(m => m.content)
				: []
		},
		locationsLoading(state) {
			return state.loading;
		}
	},
	mutations: {
		setQueryLocations: generateSetChild('queryLocations'),
		setLocations: generateSetChild('locations'),
		setLocation: generateSetChild('location'),
		setDeliveryMethod: generateSetChild('deliveryMethod'),
		setDeliveryTime: generateSetChild('deliveryTime'),
		setOrderDate: generateSetChild('orderDate'),
		setOrderTime: generateSetChild('orderTime'),
		setOrderNow: generateSetChild('orderNow'),
		setOrderZip: generateSetChild('orderZip'),
		setOrderNowAvailable: generateSetChild('orderNowAvailable'),
		setLoading: generateSetChild('loading')
	}
}
